export const state = {
  // Split-screen state, keyed by orgId. Client-only (resets on reload).
  // `tiles` is the single source of truth for which maps are on the canvas: a
  // map is visible iff it's a tile. A split is active when `tiles` has >1 map;
  // the arrangement decides the grid.
  tiles: {},        // orgId -> string[] of mapId (len <= 4), ordered by slot
  arrangement: {},  // orgId -> 'lr' | 'tb' | 'quad' | 'left' | 'right' | 'top' | 'bottom'
  dividers: {},     // orgId -> { x, y } divider fractions in [0.1, 0.9]
  // Guards the one-time default-map seed so "user hid everything" (tiles empty)
  // isn't mistaken for "not yet initialized" and re-seeded.
  initialized: {},  // orgId -> boolean

  // Per-map (keyed by mapId, not orgId):
  syncEnabled: {}, // mapId -> boolean (default true) — camera sync participation

  // Which tile global map interactions should target (e.g. layer-create drawing).
  // Transient: set while a flow that targets a specific map is open, null otherwise.
  focusedTile: null, // mapId | null
}
